import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { tracking } from "shared/data";
import { useCurrentPageType } from "shared/hooks";
import { accountAtom } from "shared/lib/account";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { Container, StyledBaseLink, Text } from "./styles";

export type HeaderFeaturesMyNewsProps = HeaderFeatureCommonProps & {
  showWhenLoggedIn?: boolean;
};

export const HeaderFeaturesMyNews: FunctionComponent<HeaderFeaturesMyNewsProps> = ({
  showWhenLoggedIn = false,
  ...props
}) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const currentPageType = useCurrentPageType();

  const mastheadQueryParameter = useMemo(
    () => ({
      module: tracking.module.Masthead,
      pgtype: currentPageType,
    }),
    [currentPageType],
  );

  if (showWhenLoggedIn && !isLoggedIn) {
    return null;
  }
  return (
    <Container {...getResponsiveProps(props)}>
      <StyledBaseLink
        anchorProps={{ "aria-label": "my news" }}
        as="/mynews"
        pathname="mynews"
        query={mastheadQueryParameter}
      >
        <Text>
          <i>my</i>NEWS
        </Text>
      </StyledBaseLink>
    </Container>
  );
};

HeaderFeaturesMyNews.displayName = "HeaderFeaturesMyNews";
